<template>
  <div class="register-page">
    <img
        class="bg-img"
        src="https://xhtd888.oss-cn-hongkong.aliyuncs.com/uu8/sts/hk_login.png"
    />

    <div class="overlay">
      <van-nav-bar class="nav-bar">
        <template #left>
          <van-icon name="arrow-left" color="#fff" @click="back()" />
        </template>
      </van-nav-bar>

      <div class="content">
        <div class="hero-title">{{ $t("auth.register") }}</div>
        <div class="hero-subtitle">欢迎回来，开始探索吧</div>

        <div class="glass-card">
          <van-field
              v-model="username"
              class="field"
              :placeholder="$t('auth.username_place')"
          />

          <van-field
              v-model="password"
              :type="passwordType"
              class="field"
              :placeholder="$t('auth.pwd_place')"
          >
            <template slot="right-icon">
              <van-icon
                  :name="passwordType === 'password' ? 'closed-eye' : 'eye-o'"
                  @click="switchPasswordType"
              />
            </template>
          </van-field>

          <van-field
              v-model="confirmPassword"
              :type="passwordType"
              class="field"
              placeholder="请确认密码"
          >
            <template slot="right-icon">
              <van-icon
                  :name="passwordType === 'password' ? 'closed-eye' : 'eye-o'"
                  @click="switchPasswordType"
              />
            </template>
          </van-field>

          <van-field
              v-model="code"
              class="field"
              :placeholder="$t('auth.invite_code_place')"
          />

          <div class="agreement" @click="checked = !checked">
            <span class="check" :class="{ active: checked }">✓</span>
            <span>我已经知晓并同意开户协议各项条约</span>
          </div>

          <van-button class="register-btn" block @click="doRegister()">
            {{ $t("auth.register") }}
          </van-button>

          <div class="login-link" @click="toLogin">
            Already have an account?
            <span>Login</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  model: {
    prop: "inputValue",
    event: "input",
  },
  props: {
    inputValue: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      checked: true,
      username: "",
      code: "",
      lang: "zh",
      password: this.inputValue,
      confirmPassword: "",
      passwordType: "password",
    };
  },
  created() {
    if (localStorage.getItem("token")) {
      return window.history.back();
    }
  },
  mounted() {
    this.lang = localStorage.getItem("lang") || "zh";
  },
  methods: {
    switchPasswordType() {
      this.passwordType = this.passwordType === "password" ? "text" : "password";
    },
    back() {
      return window.history.back();
    },
    toLogin() {
      this.$router.push("Login");
    },
    doRegister() {
      if (!this.username) {
        this.$toast.fail(this.$t("auth.username_place"));
        return false;
      }

      if (!this.password) {
        this.$toast.fail(this.$t("auth.pwd_place"));
        return false;
      }

      if (!this.confirmPassword) {
        this.$toast.fail("请确认密码");
        return false;
      }

      if (this.password !== this.confirmPassword) {
        this.$toast.fail("两次密码不一致");
        return false;
      }

      if (!this.code) {
        this.$toast.fail(this.$t("auth.invite_code_place"));
        return false;
      }

      if (!this.checked) {
        this.$toast.fail(this.$t("auth.agreement"));
        return false;
      }

      this.$http({
        method: "post",
        data: {
          username: this.username,
          password: this.password,
          code: this.code,
          lang: this.lang,
        },
        url: "member_register",
      }).then((res) => {
        if (res.code === 200) {
          this.$toast.success(res.msg);
          localStorage.setItem("token", res.data);
          this.$router.push("Mine");
        } else {
          this.$toast.fail(res.msg);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.register-page {
  position: relative;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  background: #000;
}

.register-page * {
  box-sizing: border-box;
}

.bg-img {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center top;
  z-index: 1;
}

.overlay {
  position: relative;
  z-index: 2;
  width: 100%;
  height: 100%;
  background: linear-gradient(
      180deg,
      rgba(0, 0, 0, 0.18) 0%,
      rgba(55, 32, 65, 0.28) 38%,
      rgba(94, 58, 102, 0.82) 100%
  );
}

.overlay::after {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 48%;
  z-index: 1;
  pointer-events: none;
  background: linear-gradient(
      180deg,
      rgba(118, 80, 130, 0) 0%,
      rgba(118, 80, 130, 0.4) 35%,
      rgba(93, 58, 100, 0.9) 100%
  );
}

.content {
  position: relative;
  z-index: 3;
  width: 100%;
  padding: 270px 48px 0;
}

.hero-title {
  color: #fff;
  font-size: 54px;
  font-weight: 900;
  line-height: 1;
  letter-spacing: 1px;
  text-shadow: 0 5px 18px rgba(0, 0, 0, 0.38);
}

.hero-subtitle {
  margin-top: 14px;
  margin-bottom: 30px;
  color: #fff;
  font-size: 23px;
  font-weight: 500;
  line-height: 1.2;
  text-shadow: 0 3px 12px rgba(0, 0, 0, 0.3);
}

.glass-card {
  position: relative;
  width: 100%;
  margin: 0 auto;
  padding: 38px 32px 36px;
  border-radius: 24px;
  background: rgba(105, 82, 108, 0.58);
  border: 1px solid rgba(255, 255, 255, 0.22);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  box-shadow:
      0 38px 78px rgba(35, 20, 42, 0.52),
      0 16px 34px rgba(0, 0, 0, 0.25),
      inset 0 1px 0 rgba(255, 255, 255, 0.2);
}

.field {
  margin-bottom: 20px;
  border-radius: 10px;
  overflow: hidden;
  background: #fff;
}

::v-deep .van-cell {
  height: 58px !important;
  min-height: 58px !important;
  padding: 0 22px !important;
  border-radius: 10px !important;
  background: #fff !important;
}

::v-deep .van-field__body {
  height: 58px !important;
}

::v-deep .van-field__control {
  height: 58px !important;
  line-height: 58px !important;
  color: #111 !important;
  font-size: 28px !important;
  font-weight: 500;
  text-align: left !important;
}

::v-deep .van-field__control::placeholder,
::v-deep input::placeholder {
  color: #c6c6c6 !important;
  font-size: 20px !important;
  font-weight: 500;
}

::v-deep .van-field__right-icon {
  display: flex;
  align-items: center;
  height: 58px;
}

::v-deep .van-field__right-icon .van-icon {
  color: #999;
  font-size: 24px !important;
}

.agreement {
  display: flex;
  align-items: center;
  margin: 4px 0 28px 6px;
  color: #fff;
  font-size: 27px;
  font-weight: 500;
}

.check {
  width: 16px;
  height: 16px;
  margin-right: 7px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  color: transparent;
  font-size: 23px;
  line-height: 1;
}

.check.active {
  background: #e8478b;
  color: #fff;
}

.register-btn {
  width: 100% !important;
  height: 70px !important;
  border: none !important;
  border-radius: 36px !important;
  background: linear-gradient(90deg, #f36b68 0%, #e43e83 100%) !important;
  color: #fff !important;
  font-size: 28px !important;
  font-weight: 900 !important;
  box-shadow:
      0 18px 36px rgba(226, 63, 130, 0.38),
      0 8px 18px rgba(0, 0, 0, 0.16);
}

::v-deep .van-button__text {
  font-size: 28px !important;
  font-weight: 900 !important;
}

.login-link {
  margin-top: 32px;
  color: rgba(255, 255, 255, 0.78);
  font-size: 28px;
  font-weight: 600;
  text-align: center;
}

.login-link span {
  margin-left: 12px;
  color: #fff;
  font-weight: 900;
  text-decoration: underline;
}

::v-deep .van-nav-bar {
  background: transparent !important;
}

::v-deep .van-nav-bar::after {
  display: none !important;
}

::v-deep .van-nav-bar__content {
  height: 88px !important;
}

::v-deep .van-nav-bar .van-icon {
  font-size: 36px !important;
  color: #fff !important;
}

@media screen and (max-width: 750px) {


  .hero-title {
    font-size: 54px;
  }

  .hero-subtitle {
    font-size: 23px;
  }

  .glass-card {
    padding: 38px 32px 36px;
  }
}
</style>